"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
var FloatingLabelInput_1 = require("./FloatingLabelInput");
var CheckBoxBuilder_1 = require("./CheckBoxBuilder");
var ToolTipComp_1 = require("./ToolTipComp");
var isTooShort = function (password) { return !(password.length < 8) && !(password.length > 20); };
var ReactPasswordStrength = function (props) {
    var _a = react_1.useState({
        score: 0,
        isValid: false,
        password: ''
    }), passwordprops = _a[0], setPasswordprops = _a[1];
    var _b = react_1.useState(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message1", checked: false })), max8digit = _b[0], setMax8digitCondition = _b[1];
    var _c = react_1.useState(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message2", checked: false })), upperCase = _c[0], setUpperCaseCondition = _c[1];
    var _d = react_1.useState(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message3", checked: false })), lowerCase = _d[0], setLowerCaseCondition = _d[1];
    var _e = react_1.useState(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message4", checked: false })), digits = _e[0], setDigitsCondition = _e[1];
    var _f = react_1.useState(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message5", checked: false })), specialSymbol = _f[0], setSpecialSymbolCondition = _f[1];
    var handleChange = function (password) {
        var score = 0;
        var result;
        if (isTooShort(password)) {
            setMax8digitCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message1", checked: true }));
        }
        else {
            setMax8digitCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message1", checked: false }));
        }
        if (validateSpecialCharacter(password)) {
            setSpecialSymbolCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message5", checked: true }));
        }
        else {
            setSpecialSymbolCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message5", checked: false }));
        }
        if (validateCapitalCharacter(password)) {
            setUpperCaseCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message2", checked: true }));
        }
        else {
            setUpperCaseCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message2", checked: false }));
        }
        if (validateSmallCharacter(password)) {
            setLowerCaseCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message3", checked: true }));
        }
        else {
            setLowerCaseCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message3", checked: false }));
        }
        if (validateDigit(password)) {
            setDigitsCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message4", checked: true }));
        }
        else {
            setDigitsCondition(React.createElement(CheckBoxBuilder_1.default, { intl: props.intl, label: "tooltipMesg.message4", checked: false }));
        }
    };
    var validateSpecialCharacter = function (password) {
        var regEx = /[!@#$%^&*(),.?":{}|<>]/;
        return regEx.test(password);
    };
    var validateCapitalCharacter = function (password) {
        var regEx = /[A-Z]/;
        return regEx.test(password);
    };
    var validateSmallCharacter = function (password) {
        var regEx = /[a-z]/;
        return regEx.test(password);
    };
    var validateDigit = function (password) {
        var regEx = /[0-9]/;
        return regEx.test(password);
    };
    var component = React.createElement(FloatingLabelInput_1.FloatingLabelInput, { id: "password", dispalyLabel: props.dispalyLabel, onChange: props.onChange, value: props.value, inlineError: props.inlineError, setInLineError: props.setInLineError, type: "password", inlineMsg: "Password is required", handleChange: handleChange });
    return (React.createElement(ToolTipComp_1.default, { intl: props.intl, max8digit: max8digit, component: component, upperCase: upperCase, lowerCase: lowerCase, digits: digits, specialSymbol: specialSymbol }));
};
exports.default = ReactPasswordStrength;
//# sourceMappingURL=ReactPasswordStrength.js.map